export default __webpack_public_path__ + "static/media/0348.68eaebf1.jpg";